import { memo, useContext, useEffect } from 'react'
import styled from 'styled-components'
import { useAppDispatch } from 'store'
import { setTypeTobePrinted } from 'redux/printArea'
import { setTypePrintArea } from 'storeContext/actions/printArea'
import {
  TemplateOrderPackerPacking,
  TemplateOrderPackerWaitingDriver,
  TemplateOrderPickerPicking,
  TemplateInboundPo,
  TemplateSupplyOrderPickingList,
  TemplateInboundCompleteSO_v2,
  TemplateDeliveryOrders,
  TemplateCetakQR,
  TemplatePurchaseOrderLite,
  TemplateCetakPackageID,
  TemplatePrintPackageIdMobile,
  TemplateSupplyOrderDeliveryNote,
  TemplateFPOPrintBarcode,
  TemplateCetakKoliID,
  TemplateCetakSupplyOrderCheckQty,
  TemplatePrintSTO,
  TemplatePrintSTOBeritaAcara,
  TemplateRelabelAstroGoods,
  TemplateGrabMart,
  TemplateAstroKitchen,
  TemplateSupplyOrderDeliveryNoteOld,
  TemplateGiftNote,
  TemplateKitchenModifierReceipt,
  TemplatePriceTagPrint,
  TemplatePurchaseOrderLiteNewWithTax,
  TemplatePrintBarcodeSloc,
  TemplateSortingLabel,
} from './component'
import store from 'storeContext'
import TypeTemplateList from 'helpers/typeTemplateList'
import { usePrintArea } from './usePrintArea'

function PrintArea() {
  const { state: statePrintArea, dispatch: dispatchPrintArea } = useContext(store.PrintAreaContext)
  const {
    state: { typeTobePrinted },
  } = usePrintArea()
  const dispatch = useAppDispatch()

  // A Context-driven print just fired — clear any stale Redux value so it can't
  // keep shadowing later Context-driven prints.
  useEffect(() => {
    if (statePrintArea.typeToBePrinted && typeTobePrinted) {
      dispatch(setTypeTobePrinted(''))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statePrintArea.typeToBePrinted])

  // A Redux-driven print (e.g. Rack Detail's SLOC barcode) just fired — clear any
  // stale Context value so it can't keep shadowing later Redux-driven prints.
  useEffect(() => {
    if (typeTobePrinted && statePrintArea.typeToBePrinted) {
      dispatchPrintArea(setTypePrintArea(''))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeTobePrinted])

  const renderTemplate = () => {
    switch (statePrintArea.typeToBePrinted || typeTobePrinted) {
      case TypeTemplateList.OrderPackerWaitingDriver:
        return <TemplateOrderPackerWaitingDriver />
      case TypeTemplateList.OrderPickerPicking:
        return <TemplateOrderPickerPicking />
      case TypeTemplateList.OrderPackerPacking:
        return <TemplateOrderPackerPacking />
      case TypeTemplateList.InboundPo:
        return <TemplateInboundPo />
      case TypeTemplateList.SupplyOrderCekList:
        return <TemplateSupplyOrderPickingList />
      case TypeTemplateList.SupplyOrderCetakSuratJalan:
        return <TemplateSupplyOrderPickingList isSuratJalan />
      case TypeTemplateList.InboundCompleteSO:
        return <TemplateInboundCompleteSO_v2 />
      case TypeTemplateList.DeliveryOrder:
        return <TemplateDeliveryOrders />
      case TypeTemplateList.PurchaseOrderLiteQRCodeExpire:
        return <TemplateCetakQR />
      case TypeTemplateList.PriceTagPrint:
        return <TemplatePriceTagPrint />
      case TypeTemplateList.PurchaseOrderLiteCreatePOLite:
        return <TemplatePurchaseOrderLite />
      case TypeTemplateList.PurchaseOrderLiteCreatePOLiteNewWithTax:
        return <TemplatePurchaseOrderLiteNewWithTax />
      case TypeTemplateList.PurchaseOrderLiteGeneratePackageID:
        return <TemplateCetakPackageID />
      case TypeTemplateList.PurchaseOrderLiteGeneratePackageIdMobile:
        return <TemplatePrintPackageIdMobile />
      case TypeTemplateList.PurchaseOrderLiteGenerateKoliID:
        return <TemplateCetakKoliID />
      case TypeTemplateList.SupplyOrderCheckQuantity:
        return <TemplateCetakSupplyOrderCheckQty />
      case TypeTemplateList.SupplyOrderPrintDeliveryNoteV2:
        return <TemplateSupplyOrderDeliveryNote />
      case TypeTemplateList.FPOPrintBarcode:
        return <TemplateFPOPrintBarcode />
      case TypeTemplateList.StockOpname:
        return <TemplatePrintSTO />
      case TypeTemplateList.StockOpnameBeritaAcara:
        return <TemplatePrintSTOBeritaAcara />
      case TypeTemplateList.RelabelAstroGoods:
        return <TemplateRelabelAstroGoods />
      case TypeTemplateList.GrabMart:
        return <TemplateGrabMart />
      case TypeTemplateList.AstroKitchen:
        return <TemplateAstroKitchen />
      case TypeTemplateList.SupplyOrderPrintDeliveryNoteOld:
        return <TemplateSupplyOrderDeliveryNoteOld />
      case TypeTemplateList.GiftNote:
        return <TemplateGiftNote />
      case TypeTemplateList.KitchenModifierReceipt:
        return <TemplateKitchenModifierReceipt />
      case TypeTemplateList.PrintBarcodeSloc:
        return <TemplatePrintBarcodeSloc />
      case TypeTemplateList.SortingLabel:
        return <TemplateSortingLabel />
      default:
        return <div></div>
    }
  }
  return (
    <Container className="print-area order-packing-waiting-driver">{renderTemplate()}</Container>
  )
}

export default memo(PrintArea)

const Container = styled.div`
  visibility: hidden;
  position: fixed;
`
